import { Routes } from '@angular/router';
import { WelcomeComponent } from 'src/app/pages/welcome/welcome.component';
import { FormComponent } from 'src/app/pages/form/form.component';
import { SuccessComponent } from 'src/app/pages/response/success/success.component';
import { FailureComponent } from 'src/app/pages/response/failure/failure.component';
import { ErrorComponent } from 'src/app/ui/templates/error/error.component';

export const ROUTE_PATHS = {
  WELCOME: 'welcome',
  FORM: '',
  SUCCESS: 'success',
  FAILURE: 'failure',
}

export const routes: Routes = [
  { path: ROUTE_PATHS.WELCOME, component: WelcomeComponent },
  { path: ROUTE_PATHS.FORM, component: FormComponent },
  { path: ROUTE_PATHS.SUCCESS, component: SuccessComponent },
  { path: ROUTE_PATHS.FAILURE, component:  FailureComponent },
  { path: '**', component: ErrorComponent }
];
